import { render, staticRenderFns } from "./index.vue?vue&type=template&id=caced73a&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('caced73a')) {
      api.createRecord('caced73a', component.options)
    } else {
      api.reload('caced73a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=caced73a&lang=pug", function () {
      api.rerender('caced73a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vip/learningPassion/bookAndAttend/index.vue"
export default component.exports